import React from "react";

import "twin.macro";

const StepData = [
  {
    title: "Step 1",
    content:
      "Once you get in touch with us, we will share designs with you to choose from, whichever template you find appealing and convenient, we’ll use the same.",
  },
  {
    title: "Step 2",
    content:
      "Then after the payment. We’ll share a form link, which will take you to the form, where you will be required to fill in the details as per the questions that are being asked. In case of alterations or modifications, you will be called up to guide and suggest you ideas which might be helpful.",
  },
  {
    title: "Step 3",
    content:
      "Voila! Your customized perfect portfolio website is ready, it has got everything, expert suggestions, personalized touch and a creative design All that you need to do to obtain your personalized professional and crisp portfolio is get in touch with us and let us serve you with perfection.",
  },
];

const HeroSection = () => {
  return (
    <div tw="max-w-7xl mx-auto text-white min-height[80vh] flex flex-col justify-center items-center p-5">
      <div tw="space-y-10">
        <p tw="text-center text-3xl font-bold">
          All you need to do to get your crisp Profile ready
        </p>

        <div tw="grid md:grid-cols-3 gap-5">
          {StepData.map((item, index) => (
            <div tw="flex items-center justify-center h-full">
              <div tw="border border-red-600 bg-red-500 shadow-2xl p-3 rounded-md space-y-2 h-full">
                <div tw="flex text-2xl justify-center  space-x-2 items-center">
                  <p tw=" text-center font-medium">Step</p>
                  <p tw="bg-red-700 text-center px-4 text-xl py-2 rounded-full">
                    {index + 1}
                  </p>
                </div>
                <p tw="text-gray-100 text-justify">{item.content}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
export default HeroSection;
